import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { PupUserRoutingModule } from './pup-user-routing.module';


@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    PupUserRoutingModule
  ]
})
export class PupUserModule { }
